import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronThickUp = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16.0002 8.99953C15.7374 8.99949 15.4772 9.05124 15.2344 9.15184C14.9916 9.25243 14.771 9.39989 14.5852 9.58578L4.58521 19.5858C4.39956 19.7716 4.25232 19.9922 4.15191 20.2349C4.05149 20.4776 3.99987 20.7377 3.99998 21.0004C4.0001 21.2631 4.05195 21.5232 4.15258 21.7658C4.25321 22.0084 4.40064 22.2289 4.58646 22.4145C4.77228 22.6002 4.99285 22.7474 5.23558 22.8478C5.4783 22.9482 5.73842 22.9999 6.0011 22.9998C6.26377 22.9996 6.52385 22.9478 6.76648 22.8472C7.00912 22.7465 7.22956 22.5991 7.41521 22.4133L16.0002 13.8283L24.5852 22.4133C24.9603 22.7884 25.4691 22.9991 25.9996 22.9991C26.5301 22.9991 27.0388 22.7884 27.414 22.4133C27.7891 22.0382 27.9998 21.5294 27.9998 20.9989C27.9998 20.4684 27.7891 19.9596 27.414 19.5845L17.414 9.58453C17.0389 9.20986 16.5304 8.99945 16.0002 8.99953Z" />
	</svg>
);

export default ChevronThickUp;
